import { Coins } from '../../Coins';
import { JSONSerializable } from '../../../util/json';
import { AccAddress } from '../../strings';

export class MsgDeposit extends JSONSerializable<MsgDeposit.Data> {
  constructor(
    public proposal_id: number,
    public depositor: AccAddress,
    public amount: Coins
  ) {
    super();
  }

  public static fromData(data: MsgDeposit.Data): MsgDeposit {
    const {
      value: { proposal_id, depositor, amount },
    } = data;
    return new MsgDeposit(
      Number.parseInt(proposal_id),
      depositor,
      Coins.fromData(amount)
    );
  }

  public toData(): MsgDeposit.Data {
    const { proposal_id, depositor, amount } = this;
    return {
      type: 'gov/MsgDeposit',
      value: {
        proposal_id: proposal_id.toString(),
        depositor,
        amount: amount.toData(),
      },
    };
  }
}

export namespace MsgDeposit {
  export interface Data {
    type: 'gov/MsgDeposit';
    value: {
      proposal_id: string;
      depositor: AccAddress;
      amount: Coins.Data;
    };
  }
}
